import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useReactiveVar } from '@apollo/client';
import { userInfo } from '@apollo-internal/cache';
import PrivilegeNames from '../../../constants/privilegeNames';
import LegalDocuments from './LegalDocuments';
import LegalDocumentsDataProvider from '../providers/LegalDocumentsDataProvider';

const LegalDocumentsWrapper = () => {
  const { orgId: urlOrgId } = useParams();
  const currentUserInfo = useReactiveVar(userInfo);

  const canUserSearchOrganization = currentUserInfo.Privileges.includes(
    PrivilegeNames.OrganizationSearch_Standard
  );

  const shouldRedirectToSearch = !urlOrgId && canUserSearchOrganization;
  const shouldRedirectToDefault = urlOrgId && !canUserSearchOrganization;

  if (shouldRedirectToSearch) {
    return <Navigate to='/legal-documents/organization-search' replace />;
  }

  if (shouldRedirectToDefault) {
    return <Navigate to='/legal-documents' replace />;
  }

  const orgId = urlOrgId ? parseInt(urlOrgId) : currentUserInfo.LicensedOrgId;

  return (
    <LegalDocumentsDataProvider orgId={orgId}>
      <LegalDocuments />
    </LegalDocumentsDataProvider>
  );
};

export default LegalDocumentsWrapper;
